module.exports = __webpack_public_path__ + "media/images/pro_exclusive_desktop-c0b6a47c.svg";